export default __webpack_public_path__ + "static/media/322.27b9dc54.gif";